export const Data = [
  {
    type:"zh",
    content:{
      itemLi:[
        {
          span :"联系我们",
          aa:[
            {
              text1:"联系方式",
              hrf:"/contactUs",
            },
          ]
        }
        ,{
          span :"新闻中心",
          aa:[
            {
              text1:"公司新闻",
              hrf:"/news2",
            },

          ]
        },
        {
          span :"产品中心",
          aa:[
            {
              text1:"口腔Er:YAG激光治疗仪",
              hrf:"/product?path=bt1",
            },

          ]
        },
        {
          span :"关于牙客邦",
          aa:[

            {
              text1:"发展历程",
              hrf:"/aboutUs?path=bt1",
            },
            {
              text1:"核心优势",
              hrf:"/aboutUs?path=bt2",
            }
          ]
        }
      ],
      allPhone:"全国统一热线",
      icp:"本网站版权归苏州牙客邦医疗科技有限公司所有     苏ICP备2024136353号-1  苏公网安备32050602013304号"


    }
  },
  {
    type: "en",
    content: {
      itemLi:[

        {
          span :"Contact Us",
          aa:[
            {
              text1:"Contact Information",
              hrf:"/contactUs",
            },
          ]
        }
        ,{
          span :"News Center",
          aa:[
            {
              text1:"Company News",
              hrf:"/news2",
            },

          ]
        },
        {
          span :"Product Center",
          aa:[
            {
              text1:"Er:YAG Dental Laser Instrument",
              hrf:"/product?path=bt1",
            },

          ]
        },
        {
          span :"About Yacob",
          aa:[

            {
              text1:"Development History",
              hrf:"/aboutUs?path=bt1",
            },
            {
              text1:"Core Advantages",
              hrf:"/aboutUs?path=bt2",
            }
          ]
        }
      ],
      allPhone:"National Unified Hotline",
      icp:"The copyright of this website belongs to Suzhou Yacob Medical Technology Co., Ltd.  Su ICP No. 2024136353-1  Public Security Network Security Record in Jiangsu Province No. 32050602013304"
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/js/footer.js